import { cleanObject } from '@/lib/util';
import { theme } from '@/theme';

import type { CardProps } from '../../types';
import { BaseCardType } from '../BaseCardType';

export const TextType = (_props: CardProps) => {
  const props: CardProps = {
    contentAlignment: 'center',
    textAlignment: 'center',
    type: 'default',
    urlType: 'button',
    ...cleanObject(_props),
  };
  // text card has no min-height
  const withWrapperMinHeight = false;
  // text card has no withBackgroundImage
  const withBackgroundImage = false;
  // text card has background color
  const backgroundColor = {
    ...props?.backgroundColor,
    value: props.backgroundColor?.value || theme.colors.white,
  };
  // text card has heading color
  const headingTextColor = theme.colors.default;
  const processedProps = {
    ...props,
    withWrapperMinHeight,
    withBackgroundImage,
    backgroundColor,
    headingTextColor,
  };
  return (
    <BaseCardType {...processedProps} className={`${_props.type}BaseCard`} />
  );
};
